import { createDate, diffInUnits, isAfter } from '@lingoda/dates';

export const getDaysLeft = (endDate: Date, now: Date = createDate()): number => {
    if (isAfter(now, endDate)) {
        return 0;
    }

    return diffInUnits('days', endDate, now) + 1;
};
